
export const bannerType = {
    // 首页
    indexBanner: 17,
    // 首页新闻中心
    indexnewscenter: 24,
    // 新闻中心
    newscenter: 19,
    //企业文化四张图
    companyCulture4: 25,
    //企业文化八张图
    companyCulture8: 9,
    // 关于我们
    inHuiFa: 18,
    //投资者服务联络站广告位
    investor: 11,
    //产品展示顶部大图
    productDisplay: 20,
    //项目布局顶部大图
    projectLayout: 13,
    //人力资源顶部大图
    humanResources: 21,
    //投资者关系顶部大图
    investorConcern: 15,
    //联系我们顶部大图
    contactUs: 22,
    // 业务介绍背景图
    business: 26,
    // 生产园区背景图
    productionPark: 27,
    // 会展服务背景图
    exhibition: 28,
    // 物流保税背景图
    logisticsAndTaxation: 29,
    // 合作招商背景图
    investmentCooperation: 30,
   };